import UIDs from "../../../../UIDs";

const uid = UIDs.screens.chinesepark.default;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    GET_ROOMLIST_ASYNC: `${uid}.getRoomListAsync`,
    GET_ROOMLIST_SUCCESS: `${uid}.getRoomListSuccess`,
    GET_ROOMLIST_FAILURE: `${uid}.getRoomListFailure`,
    GET_MY_INFO_ASYNC: `${uid}.getMyInfoAsync`,
    GET_MY_INFO_SUCCESS: `${uid}.getMyInfoSuccess`,
    GET_MY_INFO_FAILURE: `${uid}.getMyInfoFailure`,
    GET_ALL_ROOMLIST_ASYNC: `${uid}.getAllRoomListAsync`,
    GET_ALL_ROOMLIST_SUCCESS: `${uid}.getAllRoomListSuccess`,
    GET_ALL_ROOMLIST_FAILURE: `${uid}.getAllRoomListFailure`,
    GET_PK_ROOMLIST_ASYNC: `${uid}.getPKRoomListAsync`,
    GET_PK_ROOMLIST_SUCCESS: `${uid}.getPKRoomListSuccess`,
    GET_PK_ROOMLIST_FAILURE: `${uid}.getPKRoomListFailure`,
    GET_TALK_ROOMLIST_ASYNC: `${uid}.getTalkRoomListAsync`,
    GET_TALK_ROOMLIST_SUCCESS: `${uid}.getTalkRoomListSuccess`,
    GET_TALK_ROOMLIST_FAILURE: `${uid}.getTalkRoomListFailure`,
    GET_EDU_ROOMLIST_ASYNC: `${uid}.getEduRoomListAsync`,
    GET_EDU_ROOMLIST_SUCCESS: `${uid}.getEduRoomListSuccess`,
    GET_EDU_ROOMLIST_FAILURE: `${uid}.getEduRoomListFailure`,
    GET_FOLLOW_ROOMLIST_ASYNC: `${uid}.getFollowRoomListAsync`,
    GET_FOLLOW_ROOMLIST_SUCCESS: `${uid}.getFollowRoomListSuccess`,
    GET_FOLLOW_ROOMLIST_FAILURE: `${uid}.getFollowRoomListFailure`,
    GET_SEARCH_ROOMLIST_ASYNC: `${uid}.getSearchRoomListAsync`,
    GET_SEARCH_ROOMLIST_SUCCESS: `${uid}.getSearchRoomListSuccess`,
    GET_SEARCH_ROOMLIST_FAILURE: `${uid}.getSearchRoomListFailure`,
    FOLLOW_ROOM_ASYNC: `${uid}.followRoomAsync`,
    FOLLOW_ROOM_SUCCESS: `${uid}.followRoomSuccess`,
    FOLLOW_ROOM_FAILURE: `${uid}.followRoomFailure`,
    UNFOLLOW_ROOM_ASYNC: `${uid}.unfollowRoomAsync`,
    UNFOLLOW_ROOM_SUCCESS: `${uid}.unfollowRoomSuccess`,
    UNFOLLOW_ROOM_FAILURE: `${uid}.unfollowRoomFailure`,
};

export { ActionTypes };
